/**
 * @Description: 封装Button
 * @Author Jiang
 * @Date 2020/8/17 11:15
 */
import React, {Component} from "react";
import {Button, Card, Row} from "antd";

export default class MyButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {title, onClick,type,style} = this.props
    return (
      <Button style={{borderRadius: "7%",...style}} type={type} onClick={onClick}>
        {title}
      </Button>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Button/index.js